import React, { FC, useState } from 'react';
import { InputNumber, Popover } from 'antd';
import { countFormatter } from 'common/helpers';
import { ArrowDownShort } from 'common/svg';

interface IComponentProps {
  count: number;
  limit: number;
  onChange: (value: number) => void;
}

export const RequestDistributionCount: FC<IComponentProps> = ({ count, limit, onChange }) => {
  const [value, setValue] = useState<number>(1);
  const [openPopover, setOpenPopover] = useState<boolean>(false);

  const isSplit = count !== limit;

  const toggleOpen = (open: boolean): void => {
    if (open) {
      setValue(count);
    }

    if (!open) {
      onChange(value);
    }

    setOpenPopover(open);
  };

  const changeCount = (value: number | null): void => {
    if (value) {
      setValue(value);
    }
  };

  return (
    <Popover
      overlayClassName="redesign"
      placement="bottomRight"
      content={
        <div>
          <div className="mb-2 ff-regular fs-xs">Количество оборудования</div>
          <InputNumber
            controls={false}
            suffix={`из ${limit} шт`}
            min={1}
            max={limit}
            precision={0}
            value={value}
            onChange={changeCount}
            onPressEnter={() => toggleOpen(false)}
          />
        </div>
      }
      trigger="click"
      open={openPopover}
      onOpenChange={toggleOpen}
    >
      <div className={`request-distribution-count ${isSplit ? 'request-distribution-count__split' : ''}`}>
        {isSplit ? (
          <div className="background-bright-green ff-medium fs-xs color-white">{`${count} из ${limit} шт.`}</div>
        ) : (
          <div className="ff-medium fs-xs">{countFormatter(count)}</div>
        )}
        <ArrowDownShort />
      </div>
    </Popover>
  );
};
